import {FETCH_COURSES_ALL, FETCH_COURSE, FETCH_COURSES_BY_SEARCH, FETCH_PREREQUISITES, CREATE_COURSE, UPDATE_COURSE, DELETE_COURSE, LOADING_START, LOADING_END} from '../constants/actionConstants' ; 


import * as api from '../api'

// Action Creators -- functions that return an action
// An action is an object with a type and a payload
// Ugly notation as async
export const getCourses = (page) => async (dispatch) => {
    try {
        dispatch({ type: LOADING_START }) ; 
        const {data} = await api.fetchCourses(page) ;  
        dispatch({type: FETCH_COURSES_ALL, payload: data});
        dispatch({ type: LOADING_END }) ; 
    } catch(error) {
        console.log(error.message) ; 
    }
}

export const getCourse = (id) => async (dispatch) => {
    try {
        dispatch({ type: LOADING_START }) ; 
        const {data} = await api.fetchCourse(id) ;  
        dispatch({type: FETCH_COURSE, payload: data});
        dispatch({ type: LOADING_END }) ; 
    } catch(error) {
        console.log(error.message) ; 
    }
}


export const getCoursesBySearch =(searchQuery) => async (dispatch) => {
    try {
        dispatch({ type: LOADING_START }) ; 
        const {data } = await api.fetchCoursesBySearch(searchQuery.searchString) ; 
        dispatch({type: FETCH_COURSES_BY_SEARCH, payload: data}) ; 
        dispatch({ type: LOADING_END }) ; 

    } catch (error) {
        console.log(error) 
    }
}

export const getPrerequisites =(searchQuery) => async (dispatch) => {
    try {
        dispatch({ type: LOADING_START }) ; 
        const {data } = await api.fetchPrerequisites(searchQuery.searchTags) ; 
        dispatch({type: FETCH_PREREQUISITES, payload: data}) ; 
        dispatch({ type: LOADING_END }) ; 

    } catch (error) {
        console.log(error) 
    }
}

export const createCourse = (course,navigate) => async (dispatch) => {
    try{
        dispatch({ type: LOADING_START }) ; 
        const  { data } = await api.createCourse(course) ; 
        dispatch({type: CREATE_COURSE, payload: data}) ; 
        dispatch({ type: LOADING_END }) ; 
        // navigate(`/courses/${data._id}`)
    } catch (error) {
        console.log(error) ;
    }
}

export const updateCourse = (id, post) => async (dispatch) =>{
    try{
        console.log(id, post)
        const {data} = await api.updateCourse(id, post) ;
        dispatch({type: UPDATE_COURSE, payload: data}) ; 
    } catch(error) {
        console.log(error)
    }
}

export const deleteCourse = (id) => async (dispatch) =>{
    try{
        await api.deleteCourse(id) ; 
        dispatch( {type: DELETE_COURSE, payload: id})
    } catch (error) {
        console.log(error) ; 
    }
}


